<template>
    <div class="col-12">
        <div class=" row text-center m-5">
            <h2 class="ui inverted purple text"> <strong> Upload Documents</strong></h2>
            <p class="text-muted fw-light m-3">Please provide the documents <br />indicated below:</p>
            <p>Copy of valid National ID or Passport, Proof of residence, Passport sized photo.</p>
            <small>To avoid delays, make sure your documents are clear.</small>
        </div>
        <div class="row d-flex justify-content-center align-items-center mt-3">
            <div class="col-11 col-lg-9">

                <form v-bind:class="{ 'ui form loading': isBusy() }" @submit.prevent="uploadFiles()">
                    <div class="row">
                        <div class="col d-flex align-items-center">
                            <a-select @change="startImageUpload" placeholder="Choose a document type" allowClear>
                                <a-select-option v-for="fileType of model.fileTypes" :key="fileType.label"
                                    :value="fileType.label">
                                    {{ fileType.name }}
                                </a-select-option>
                            </a-select>
                        </div>
                    </div>

                    <br />

                    <a-upload-dragger v-if="showFileUploader" name="file" :before-upload="beforeUpload"
                        @change="storeImageUpload">
                        <p class="ant-upload-drag-icon">
                            <InboxOutlined style="color:purple" />
                        </p>
                        <p class="ant-upload-text">
                            Click or drag file to this area to upload
                        </p>
                        <p class="ant-upload-hint">
                            You can upload multiple files at once
                        </p>
                    </a-upload-dragger>

                    <div v-if="model.files.length > 0">
                        <div class="row mt-5">
                            <p class="col-3 h6">Doc Type</p>
                            <p class="col-4 h6">File name</p>
                            <p class="col-2 h6">Size</p>
                            <p class="col-1 h6">Preview</p>
                            <p class="col-1 h6"></p>
                        </div>
                        <div v-for="file of model.files" :key="file.docType" class="row border-top mt-1 pt-1">
                            <div class="col-3">{{ file.docType }}</div>
                            <div class="col-4">{{ file.file.name }}</div>
                            <div class="col-2 ">{{ (file.file.size / 1028).toFixed(2) }} KB</div>
                            <div class="col-2 " style="cursor:pointer;" @click="showModalD(file.file)">
                                <i class="eye icon"></i>
                            </div>
                            <div class="col-1" style="cursor:pointer;" @click="removeItem(file)">
                                <i class="trash icon"></i>
                            </div>
                        </div>
                    </div>
                    <div v-if="showModal">
                        <div class="modal-overlay">
                            <div class="modal-content">
                                <template v-if="isPdf(fileType)">
                                    <object :data="filePreviewUrl" type="application/pdf" width="100%" height="500px">
                                        <p>PDF Preview not available</p>
                                    </object>
                                </template>
                                <template v-else-if="isImage(fileType)">
                                    <img :src="filePreviewUrl" alt="Image Preview" />
                                </template>
                                <button @click="hideModal">Close Preview</button>
                            </div>
                        </div>
                    </div>

                    <div v-if="!areFilesUploadedValid" class="text-danger mt-4">
                        {{ missingFile }}
                    </div>

                    <div class="ui purple floating message m-4">
                        <div class="mb-2">
                            <div class="header">
                                <input type="checkbox" id="checkbox" v-model="isChecked">
                                <label for="checkbox" style="color: #000;">Please indicate your agreement by selecting the box above once you have carefully read and fully understood the terms and conditions provided below :</label>
                                <div class="mt-3">
                                    <div> &nbsp;</div>
                                    <div> Please note that in order to comply with laid down RBZ guidelines your
                                    application
                                    will be <span style="color: red;">Declined</span> if the following conditions are not
                                    met.</div>
                                </div>
                            </div>
                            <ul class="list">
                                <li>The proof of residence is dated within the last 3 months from the current month.</li>
                                <li>The inputted address matches the one on the provided Proof of residence document.</li>
                                <li>Where there is a mismatch, it should be accompanied by one of the following:</li>
                                <ul class="sub-list">
                                    <li>a) A letter from your employer (where applicable)</li>
                                    <li>b) A birth certificate (if the property is in your parents' name)</li>
                                    <li>c) Marriage Certificate (where the property is in the spouse's name)</li>
                                    <li>d) An affidavit completed by the property owner (where the property is rented)</li>
                                </ul>
                                <li>The Identity documents should be valid and not expired.</li>
                                <li>Submitted documents should be visible.</li>
                            </ul>
                        </div>
                    </div>

                    <p>{{ progress }}% Uploaded</p>

                    <button class="ui button purple fluid mt-4" :disabled="!isFormValid" type="submit">Submit
                        Documents</button>
                    <button class="ui button grey fluid mt-4 mb-4" @click="back()">Back</button>
                </form>
            </div>

        </div>

    </div>
</template>
<script>
import baseMethods from "@/utils/baseMethods";
import { URLS } from "@/utils/constants";
import { http } from "@/utils/http";
import { utils } from "@/utils/utils";
import { InboxOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';


export default {
    name: 'DiasporaUploadDocuments',
    components: {
        InboxOutlined,
    },
    data() {
        return {
            customer: {
                mobileNumber: "",
                customerUid: localStorage.getItem("uid")
            },
            errors: {},
            operations: 0,
            isChecked: false,
            missingFile: '',
            progress: 0,
            model: {
                // list of objs
                files: [],
                fileTypes: [],
                docTypes: [],
            },
            tmpFileType: "",
            showFileUploader: false,
            columns: [
                {
                    title: "Type",
                    dataIndex: "dataType",
                    key: "dataType",
                },
            ],
            filePreviewUrl: null,
            fileType: null,
            showModal: false,
        };
    },
    mounted() {
        this.getTypes();
        this.getCustomerById();
        const model = localStorage.getItem('model');
        console.log('Retrieved Object Model : ', JSON.parse(model));

    },
    computed: {

        whenUploading() {
            return (
                this.progress === 100
            )
        },
        isFormValid() {
            return (
                this.validateFileUpload() && this.isChecked
                // this.model.files.length > 0
            );
        },
        areFilesUploadedValid() {
            return (
                this.validateFileUpload()
            )
        }
    },
    methods: {

        async uploadFiles() {
            const total = this.model.files.length;
            let count = 0;

            for (const file of this.model.files) {
                const formData = new FormData();
                formData.append("phone", localStorage.getItem("phone-number"));
                formData.append("customerUid", localStorage.getItem("uid"));
                formData.append("documentTypeLabel", file.docType);
                formData.append("citizenId", localStorage.getItem("identity-doc-no"));
                formData.append("files", file.file);

                this.addOp();
                console.log("uploading docs");

                try {
                    const res = await http.postFormDataNoAuth(URLS.documents + "/upload", formData);
                    utils.logger("upload result", res);

                    if (res.status === 200) {
                        count++;
                        this.progress = (count / total) * 100;
                        console.log(this.progress);
                    } else {
                        console.log("error occurred");
                    }
                    this.removeOp();
                    await this.handleGetResponse(res, true);
                } catch (error) {
                    console.log("error occurred", error);
                    this.removeOp();
                }
            }

            console.log("sent!!!");

            if (count === total) {
                this.$router.push("/account-opening/diaspora-payments");
            } else {
                console.log("failed to upload");
            }
        },

        validateFileUpload() {
            //  const uploadedFileTypes = [];

            if (!this.model.fileTypes || this.model.fileTypes.length === 0) {
                console.error('No file types defined in model');
                return false;
            }

            for (const fileType of this.model.fileTypes) {
                if (!this.model.docTypes.includes(fileType.label)) {
                    console.error(`Please upload a ${fileType.name} file.`);
                    this.missingFile = `Please upload your ${fileType.name}.`;
                    return false;
                }
            }

            console.log('Now True!!!!')

            return true;
        },

        removeItem(item) {
            let index = this.model.files.indexOf(item);
            let indexDocType = this.model.docTypes.indexOf(item.docType);
            if (index > -1) {
                this.model.files.splice(index, 1);
            }
            if (indexDocType > -1) {
                this.model.docTypes.splice(indexDocType, 1);
            }
            this.showFileUploader = true;
        },
        startImageUpload(item) {
            this.tmpFileType = item;
            this.showFileUploader = true;

        },
        cancel() {
            this.model.files = null;
        },
        storeImageUpload(info) {
            this.model.files.push(info.file);
            this.model.docTypes.push(this.tmpFileType);
            this.model.files.splice(-1);
            console.table(this.model.files);
            console.table(this.model.docTypes);

            console.log(info.file);

            this.showFileUploader = false;
        },
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                message.error("Document must be smaller than 2MB!");
                return false;
            }

            let newFile = {};
            newFile.file = file;
            newFile.docType = this.tmpFileType;

            this.model.files.push(newFile);
            return false;
        },

        getCustomerById() {
            http
                .getIdentity(
                    URLS.customerByPhone + localStorage.getItem("phone-number")
                ).then((res) => {
                    console.log(res);
                    localStorage.setItem("uid", res.body.uid);
                    this.customer.customerUid = res.body.uid;
                });
        },
        getTypes() {
            this.getNoAuth(URLS.documents + "/types")
                .then((response) => (this.model.fileTypes = response.body));

            console.log(this.model.fileTypes);
        },
        handleFileUpload(event) {
            const file = event.target.files[0];
            this.fileType = file.type;
            this.filePreviewUrl = URL.createObjectURL(file);
        },
        isPdf(fileType) {
            return fileType === 'application/pdf';
        },
        isImage(fileType) {
            return fileType.startsWith('image/');
        },
        showModalD(file) {
            this.fileType = file.type;
            this.filePreviewUrl = URL.createObjectURL(file);
            this.showModal = true;
        },
        hideModal() {
            this.showModal = false;
        },
        next() {

        },
        back() {
            this.$router.push("/account-opening/diaspora-signature");
        },
        ...baseMethods,
    }
};
</script>